// GENERATED FILE - DO NOT EDIT

// This file has been automatically generated. Any modifications made to this file will be overwritten the next time it is regenerated. Please refrain from editing this file directly.

import PhoneNumberData from '../../types/PhoneNumberData';

import { format1 } from '../../constants';

import { format5 } from '../../constants';

/** South Africa */
const ZA: PhoneNumberData = [27, 'ZA', 6, format1, 9, format5];

export default ZA;
